import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};
const postPetFormThreeSlice = createSlice({
  name: "postPetFormThree",
  initialState,
  reducers: {
    postPetFormThreeStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postPetFormThreeSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    postPetFormThreeDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },

    postPetFormThreeFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postPetFormThreeStart,
  postPetFormThreeSuccess,
  postPetFormThreeFailure,
  postPetFormThreeDataSuccess,
  clearError,
  clearMessage,
} = postPetFormThreeSlice.actions;

export default postPetFormThreeSlice.reducer;
